export const eventParticipantStatuses = [
  'present',
  'absent',
  'tentative',
  'late',
  'unknown',
  'standby',
  'missing',
] as const

export const unavailableParticipantStatuses: EventParticipantStatus[] = [
  'absent',
  'missing',
  'unknown',
]

export const presentParticipantStatuses: EventParticipantStatus[] = [
  'present',
  'standby',
]

type EventParticipantStatus = typeof eventParticipantStatuses[number]
export default EventParticipantStatus
